import sdk from '@trazi/billingv2/sdk/node';

const billingV2SDK = window => {
  return sdk(`${window.location.origin}/api`);
};

export default billingV2SDK;
